var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { colors, fontWeights, fontSizes } from '../styleConstants';
var NewIndicatorContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  width: ", "px;\n"], ["\n  position: relative;\n  width: ", "px;\n"])), function (p) { return p.width; });
var Indicator = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 2px 8px;\n  background: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  text-align: center;\n  border-radius: 10px;\n  display: inline-block;\n  position: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  color: ", ";\n  z-index: 100;\n\n  ", "\n"], ["\n  padding: 2px 8px;\n  background: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  text-align: center;\n  border-radius: 10px;\n  display: inline-block;\n  position: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  color: ", ";\n  z-index: 100;\n\n  ", "\n"])), function (p) {
    if (p.color in colors)
        return colors[p.color];
    return p.color;
}, fontSizes.medium, fontWeights.bold, function (p) { return (p.inline ? 'static' : 'absolute'); }, function (p) {
    if (p.position === 'top-left' || p.position === 'top-right')
        return "\n      top: -4px;\n    ";
}, function (p) {
    if (p.position === 'bottom-left' || p.position === 'bottom-right')
        return "\n      bottom: -4px;\n    ";
}, function (p) {
    if (p.position === 'top-left' || p.position === 'bottom-left')
        return "\n      left: -8px;\n    ";
}, function (p) {
    if (p.position === 'top-right' || p.position === 'bottom-right')
        return "\n      right: -8px;\n    ";
}, colors.trueWhite, function (p) {
    return p.pulsate &&
        "\n    animation: pulse 2s infinite;\n\n    @keyframes pulse {\n      0% {\n        transform: scale(1);\n      }\n\n      70% {\n        transform: scale(0.95);\n      }\n\n      100% {\n        transform: scale(1);\n      }\n    }\n  ";
});
var NewIndicator = function (_a) {
    var children = _a.children, _b = _a.text, text = _b === void 0 ? 'New' : _b, _c = _a.color, color = _c === void 0 ? 'accentTeal' : _c, _d = _a.position, position = _d === void 0 ? 'top-left' : _d, _e = _a.pulsate, pulsate = _e === void 0 ? true : _e;
    var _f = useState(), width = _f[0], setWidth = _f[1];
    if (!children)
        return (React.createElement(Indicator, { inline: true, pulsate: pulsate, color: color, position: position }, text));
    var childRef = useRef(null);
    // clone child so we can add a ref to it without directly referencing the child's properties
    // this is the best practice for what i could find for this - tolby
    var clonedChildren = React.cloneElement(children, { ref: childRef });
    useEffect(function () {
        var _a;
        if (!width) {
            setWidth((_a = childRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width);
        }
    }, [width]);
    return (React.createElement(NewIndicatorContainer, { width: width !== null && width !== void 0 ? width : 0 },
        React.createElement(Indicator, { inline: false, color: color, position: position, pulsate: pulsate }, text),
        clonedChildren));
};
export default NewIndicator;
var templateObject_1, templateObject_2;
